import TYPES from './types';

function fieldBlur(field = {}, linkTo = {}) {
  return { type: TYPES.FIELD_BLUR, field, linkTo };
}

function fieldFocus(fieldKey) {
  return { type: TYPES.FIELD_FOCUS, key: fieldKey };
}

function passwordInput(key, value) {
  return { type: TYPES.PASSWORD_INPUT, key, value };
}

function submitError(newState) {
  return { type: TYPES.SUBMIT_ERROR, newState };
}

export default {
  fieldBlur,
  fieldFocus,
  passwordInput,
  submitError,
};
